import React from "react";
import { ArrowLeft } from "lucide-react";
import { cn } from "@/components/common/utils";

interface CarouselLeftButtonProps {
  onClick: () => void;
  isDisabled: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export default function CarouselLeftButton({
  onClick,
  isDisabled,
  className,
  style,
}: CarouselLeftButtonProps) {
  return (
    <button
      onClick={onClick}
      style={style}
      className={cn(
        "absolute left-4 top-1/2 transform -translate-y-1/2 z-20 p-2 bg-white hover:bg-neutral-100 text-primary-blue rounded-full transition-all duration-500 shadow-[0_4px_4px_rgba(0,0,0,0.25)] border border-neutral-200",
        isDisabled &&
          "bg-transparent text-transparent shadow-none opacity-0 border-transparent",
        className
      )}
      aria-label="Scroll left"
      aria-hidden={isDisabled ? "true" : "false"}
    >
      <ArrowLeft className="w-5 h-5" />
    </button>
  );
}
